<template>
    <div class="root-container">
        <div class="chat-container">
            <div v-if="!ready">
                <LoadingSpinner/>
            </div>
            <div v-else class="chat-history">
                <div v-for="message in chatHistory.messages" :key="message.id" class="message-wrapper">
                    <div v-if="message.role === 'user'" class="message-wrapper-user">
                        <UserMessage :message="message.content"/>
                    </div>
                    <div v-else-if="message.role === 'assistant'" class="message-wrapper-assistant">
                        <AssistantMessage :message="message.content"/>
                    </div>
                </div>
            </div>
            <SendTextInput @send="handleSend"/>
        </div>
    </div>
</template>

<script>
import SendTextInput from '../components/chat/SendTextInput.vue'
import UserMessage from '../components/chat/UserMessage.vue'
import AssistantMessage from '@/components/chat/AssistantMessage.vue'
import ChatHistory from '../chathistory.js'
import ChatService from '@/service/chat.js'
import LoadingSpinner from '@/components/home/LoadingSpinner.vue'
import { getBackendURL } from '@/util.js';
import { Message } from '@/msg'
export default {
    name: 'ChatRecom',
    components: {
        SendTextInput,
        UserMessage,
        AssistantMessage,
        LoadingSpinner
    },
    data() {
        const baseURL = getBackendURL();
        return {
            es: null,
            openStreamURL: `${baseURL}/v1/thread/assistant/stream`,
            ready: false,
            chatService: new ChatService(),
            chatHistory: new ChatHistory()
        }
    },
    async mounted() {
        let threadIds = await this.getThreadIds()
        if (threadIds.length == 0) {
            this.ready = true
            return
        }
        if (threadIds.length > 1) {
            alert("Multiple threads found, not implemented")
        }
        let targetThreadID = threadIds[0]
        this.chatHistory.threadID = targetThreadID
        this.chatHistory.messages = await this.getMsgs(targetThreadID)
        this.ready = true
    },
    beforeUnmount() {
        if (this.es) {
            this.es.close()
        }
    },
    methods: {
        openStream(threadID) {
            if (this.es) {
                this.es.close()
            }
            this.es = new EventSource(
                `${this.openStreamURL}/${threadID}`,
                { withCredentials: true }
            )
            this.es.addEventListener("delta", (e) => {
                let chunk = atob(e.data)
                let num_msgs = this.chatHistory.messages.length
                let last_msg = this.chatHistory.messages[num_msgs - 1]
                if(last_msg.role == "user"){
                    this.chatHistory.messages.push(new Message("assistant", chunk))
                    return
                }
                last_msg.content += chunk
                last_msg.id = crypto.randomUUID()
            })
            this.es.addEventListener("done", () => {
                this.es.close()
                this.es = null
            })
        },
        async handleSend(content) {
            let msg = new Message("user", content)
            this.chatHistory.messages.push(msg)
            let threadID = this.chatHistory.threadID
            if(this.chatHistory.messages.length == 1){
                let res = await this.chatService.createThread(msg)
                if (res.error) {
                    alert("Error creating thread: " + res.error)
                    return
                }
                threadID = res.data
                this.chatHistory.threadID = threadID
            } else {
                let res = await this.chatService.createMsg(msg, threadID)
                if (res.error) {
                    alert("Error creating msg: " + res.error)
                    return
                }
            }
            this.openStream(threadID)
            this.chatService.generate(threadID)
        },
        async getMsgs(threadID) {
            let res = await this.chatService.getMsgs(threadID, 0, 50, 'ASC')
            if (res.error) {
                console.error(res.error)
            }
            return res.msgs
        },
        async getThreadIds() {
            let res = await this.chatService.getThreads(0, 50, 'ASC')
            if (res.error) {
                console.error(res.error)
            }
            return res.data.map(thread => thread.id)
        }
    }
}
</script>

<style lang="scss" scoped>
.root-container {
    background-color:black;
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;

    .chat-container {
        background-color:black;
        height: 80%;
        width: 100%;
        max-width: 688px;

        .chat-history {
            display: flex;
            flex-direction: column;
            padding: 0 12px;
        }
    }
}
.message-wrapper {
    display: flex;
    margin: 4px 0;
    .message-wrapper-user{
        margin-left: auto;
    }
    .message-wrapper-assistant{
        margin-right: auto;
    }
}
</style>
